import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';

import { isNodeEnvironment } from '../../js/utils-fetch-data-json.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';

export async function fetchBlogCategoryByCategoryID(selectedBlogCategoryID) {
    try {

        console.log(`✅ Fetching Single blog category with ID '${selectedBlogCategoryID}'`);


    //get the datat from fetchAllBlogCategories and filter it by selectedBlogCategoryID and return first
    const allCategories = await fetchAllBlogCategories();

    const filteredCategories = allCategories.filter(
      category => category.articleCategoryID == selectedBlogCategoryID
      );

    if (filteredCategories.length > 0) {
      console.log(`✅ Loaded single blog category with ID '${selectedBlogCategoryID}'`);
      return filteredCategories[0];
    } else
    {
      console.warn(`⚠️ No blog category found with ID '${selectedBlogCategoryID}'`);
      return {};
    }
  } catch (error) {
    console.error('❌ Error fetching single blog categories', error);
    return {};
  }
}

export async function fetchAllBlogCategories(forceRefresh = false) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching all blog categories from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllArticleCategoriesAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

        if (!response.ok) throw new Error('Failed to fetch all blog categories from the server');

        const finalResult = await response.json();

        console.log('🌐 Fetched all blog categories from the server');

        return finalResult;

    }
    else
    {
      const storageKey = `blog_categories_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      if (!forceRefresh) {
        const cached = loadFromLocalStorage(storageKey);
        const expiryTime = loadFromLocalStorage(expiryKey);

        if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
          console.log('✅ Loaded all blog categories from local storage');
          return cached;
        }
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllArticleCategoriesAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch all blog categories from the server');

      const finalResult = await response.json();
      saveToLocalStorage(storageKey, finalResult);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);

      console.log('🌐 Fetched all blog categories from the server');
      return finalResult;
    }
  } catch (error) {
    console.error('❌ Error fetching all blog categories', error);
    return [];
  }
}

export async function fetchGetAllFeaturedArticlesBlogHome() {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching featured articles from live API');

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllFeaturedArticlesBlogHomeAsync?languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetAllFeaturedArticlesBlogHomeAsync  from server`);
      const finalResult = await response.json();
      return finalResult;
    } else {
        const storageKey = `blog_home_featured_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetAllFeaturedArticlesBlogHomeAsync from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllFeaturedArticlesBlogHomeAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetAllFeaturedArticlesBlogHomeAsync  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetAllFeaturedArticlesBlogHomeAsync from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetching blog home page featured articles:', error);
    return [];
  }
}

export async function fetchGetAllRecentArticlesBlogHome() {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching featured articles from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllRecentArticlesBlogHomeAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetAllRecentArticlesBlogHome  from server`);
      const finalResult = await response.json();
      return finalResult;
    } else {
        const storageKey = `blog_home_recent_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetAllRecentArticlesBlogHome from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllRecentArticlesBlogHomeAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetAllRecentArticlesBlogHome  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetAllRecentArticlesBlogHome from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetchGetAllRecentArticlesBlogHome:', error);
    return [];
  }
}

export async function fetchGetAllBlogArticlesByBlogCategoryIDForBlogCategoryPage(
    selectedBlogCategoryID
) {
    try {
        if (isNodeEnvironment()) {
            console.log('🌐 Static build: fetching GetAllBlogArticlesByBlogCategoryIDForBlogCategoryPage from live API');
            const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllBlogArticlesByBlogCategoryIDForBlogCategoryPage?blogCategoryID=${selectedBlogCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
            const response = await fetch(apiEndPoint);
            if (!response.ok)
                throw new Error(
                    `Failed to fetch fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage  from server`
                );
            const finalResult = await response.json();
            return finalResult;
        } else {
            const storageKey = `blog_articles_in_category_${selectedBlogCategoryID}_${appState.SiteLanguageCookie}`;
            const expiryKey = `${storageKey}_expiry`;
            const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
            // Check cache first
            const cached = loadFromLocalStorage(storageKey);
            const expiryTime = loadFromLocalStorage(expiryKey);
            if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
                console.log(`✅ Loaded All  GetAllBlogArticlesByBlogCategoryIDForBlogCategoryPage from cache`);
                return cached;
            }

            const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllBlogArticlesByBlogCategoryIDForBlogCategoryPage?blogCategoryID=${selectedBlogCategoryID}&languageCode=${appState.SiteLanguageCookie}`;

            const response = await fetch(apiEndPoint);
            if (!response.ok)
                throw new Error(`Failed to fetch GetAllBlogArticlesByBlogCategoryIDForBlogCategoryPage  from server`);
            const allSubcategories = await response.json();
            // Save to localStorage
            saveToLocalStorage(storageKey, allSubcategories);
            saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
            console.log(`🌐 Fetched GetAllBlogArticlesByBlogCategoryIDForBlogCategoryPage from the server`);
            return allSubcategories;
        }
    } catch (error) {
        console.error('❌ Error fetching GetAllBlogArticlesByBlogCategoryIDForBlogCategoryPage:', error);
        return [];
    }
}
export async function fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage(
  selectedBlogCategoryID
) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching featured articles from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPageAsync?blogCategoryID=${selectedBlogCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(
          `Failed to fetch fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage  from server`
        );
      const finalResult = await response.json();
      return finalResult;
    } else {
        const storageKey = `blog_category_featured_${selectedBlogCategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetAllFeaturedArticlesBlogHomeAsync from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPageAsync?blogCategoryID=${selectedBlogCategoryID}&languageCode=${appState.SiteLanguageCookie}`;

      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetAllFeaturedArticlesBlogHomeAsync  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetAllFeaturedArticlesBlogHomeAsync from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetching blog home page featured articles:', error);
    return [];
  }
}
export async function fetchGetAllRecentArticlesByBlogCategoryIDForBlogCategoryPage(
  selectedBlogCategoryID
) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching recent articles from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllRecentArticlesByBlogCategoryIDForBlogCategoryPageAsync?blogCategoryID=${selectedBlogCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetAllRecentArticlesBlogHome  from server`);
      const finalResult = await response.json();
      return finalResult;
    } else {
        const storageKey = `blog_category_recent_${selectedBlogCategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetAllRecentArticlesBlogHome from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetAllRecentArticlesByBlogCategoryIDForBlogCategoryPageAsync?blogCategoryID=${selectedBlogCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetAllRecentArticlesBlogHome  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetAllRecentArticlesBlogHome from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetchGetAllRecentArticlesByBlogCategoryIDForBlogCategoryPage:', error);
    return [];
  }
}

export async function fetchGetBlogArticleForBlogArticlePage(
  selectedArticleCategoryID,
  selectedArticleID
) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching blog article from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetBlogArticleForBlogArticlePageAsync?articleID=${selectedArticleID}&articleCategoryID=${selectedArticleCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogArticleForBlogArticlePage  from server`);
      const finalResult = await response.json();
      return finalResult;
    } else {
        const storageKey = `blog_article_${selectedArticleID}_category_${selectedArticleCategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetBlogArticleForBlogArticlePage from cache`);
        return cached;
      }

      //curl - X 'GET' \
      //'https://localhost:7009/api/BlogDataService/GetBlogArticleForBlogArticlePageAsync?articleID=43&articleCategoryID=24&languageCode=en' \
      //-H 'accept: text/plain'

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetBlogArticleForBlogArticlePageAsync?articleID=${selectedArticleID}&articleCategoryID=${selectedArticleCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch fetchGetBlogArticleForBlogArticlePage  from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched fetchGetBlogArticleForBlogArticlePage from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetching fetchGetBlogArticleForBlogArticlePage:', error);
    return [];
  }
}
export async function fetchGetRelatedBlogArticlesForBlogArticlePageByArticleID(selectedArticleID) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching related articles from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetRelatedBlogArticlesForBlogArticlePageByArticleIDAsync?articleID=${selectedArticleID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(
          `Failed to fetch fetchGetRelatedBlogArticlesForBlogArticlePageByArticleID  from server`
        );
      const finalResult = await response.json();
      return finalResult;
    } else {
        const storageKey = `blog_related_articles_${selectedArticleID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetBlogArticleForBlogArticlePage from cache`);
        return cached;
      }

      //curl - X 'GET' \
      //'https://localhost:7009/api/BlogDataService/GetBlogArticleForBlogArticlePageAsync?articleID=43&articleCategoryID=24&languageCode=en' \
      //-H 'accept: text/plain'

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetRelatedBlogArticlesForBlogArticlePageByArticleIDAsync?articleID=${selectedArticleID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(
          `Failed to fetch fetchGetRelatedBlogArticlesForBlogArticlePageByArticleID  from server`
        );
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(
        `🌐 Fetched fetchGetRelatedBlogArticlesForBlogArticlePageByArticleID from the server`
      );
      return allSubcategories;
    }
  } catch (error) {
    console.error(
      '❌ Error fetching fetchGetRelatedBlogArticlesForBlogArticlePageByArticleID:',
      error
    );
    return [];
  }
}

export async function fetchGetRelatedProductsForBlogArticlePageByArticleID(selectedArticleID) {
  try {
    if (isNodeEnvironment()) {
      console.log('🌐 Static build: fetching related products from live API');
      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetRelatedProductsForBlogArticlePageByArticleIDAsync?articleID=${selectedArticleID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(
          `Failed to fetch fetchGetRelatedProductsForBlogArticlePageByArticleID  from server`
        );
      const finalResult = await response.json();
      return finalResult;
    } else {
        const storageKey = `blog_related_products_${selectedArticleID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All  fetchGetBlogArticleForBlogArticlePage from cache`);
        return cached;
      }

      //curl - X 'GET' \
      //'https://localhost:7009/api/BlogDataService/GetBlogArticleForBlogArticlePageAsync?articleID=43&articleCategoryID=24&languageCode=en' \
      //-H 'accept: text/plain'

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/BlogDataService/GetRelatedProductsForBlogArticlePageByArticleIDAsync?articleID=${selectedArticleID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(
          `Failed to fetch fetchGetRelatedProductsForBlogArticlePageByArticleID  from server`
        );
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(
        `🌐 Fetched fetchGetRelatedProductsForBlogArticlePageByArticleID from the server`
      );
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetching fetchGetRelatedProductsForBlogArticlePageByArticleID:', error);
    return [];
  }
}
